import React, { Component } from 'react';
import { BASE } from '../api/api'
import cachios from 'cachios'
import article from '../assets/Article.png'
import pdf from '../assets/pdfd.png'

class ArchiveCont extends Component {
    constructor(props) {
        super(props);
        this.state = {
            desc: props.filter,
        }
    }

    apicall(filter) {
        console.log(BASE + 'api/archives_search?' + filter, 'xxx')
        let apply, length = 0
        if (filter == 'everything')
            apply = 'api/archives_search'
        else
            apply = 'api/archives_search?' + filter
        cachios.get(BASE + apply, {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                this.setState({
                    files: data.data.data.view_data,
                })
                data.data.data.view_data.map((ind) => {
                    if (ind.event_report_url)
                        length = length + 1
                })
                console.log(length, 'length')
                this.setState({
                    length: length
                })
            })
            .catch((err) => {
                console.log('not found')
            })

    }
    componentWillMount() {
        this.apicall(this.state.desc)

    }

    componentWillReceiveProps(nextProps) {
        this.apicall(nextProps.filter)
    }


    render() {

        return (
            <div className="main-content listing archcontents">
                <div className="container basicpage">
                    {this.state.files ?
                        <div className="projects">
                            {this.state.files.length != 0 ? this.state.files.map((inst, index) => {
                                if (inst.event_report_url)
                                    return (
                                        <div className='project_list'>
                                            {inst.field_image_url ?
                                                <img src={BASE + inst.field_image_url} /> : <img src={article} />}
                                            <div className="title">
                                                <span className="field-content">
                                                    <div className='project_head'>
                                                        {inst.event_report_url ?
                                                            <a target='_blank' href={BASE + inst.event_report_url[0]} download>
                                                                {inst.title[0].charAt(0).toUpperCase() + inst.title[0].slice(1)}
                                                            </a>
                                                            :
                                                            <p className="archive-nonurl">{inst.title[0].charAt(0).toUpperCase() + inst.title[0].slice(1)}</p>}

                                                    </div>
                                                    {/* {inst.event_report_url?<div className='proj_pdf'>
                                                <img src={pdf} alt='pdf'/>
                                                <a target='_blank' href={BASE+inst.event_report_url[0]} download>Download</a>
                                            </div>:''} */}
                                                </span>
                                            </div>

                                        </div>
                                    )
                            }) : ''}
                            {this.state.length == 0 ? <p>No Files</p> : ''}


                        </div> : ''}


                </div>

            </div>
        )


    }

}


export default ArchiveCont;
